
import React from 'react';
import styles from './_google-map.module.scss';
import { TabName } from '../Views/OrderEditor/OrderEditorTabs';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import MapIcon from '@mui/icons-material/Map';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';

export interface GoogleMapProps {
  googleMapsIframeSrc: string;
  navigate: (tabName: TabName) => void;
}

export default function GoogleMap (props:  GoogleMapProps) {
  return (
    <div className={styles.googleMapContainer}>
      <Card>
        <CardHeader
          avatar={<MapIcon fontSize="small" />}
          title="Map"
          action={
            <IconButton size="small" onClick={() => props.navigate && props.navigate("Applicant")}>
              <EditIcon fontSize="small" />
            </IconButton>
          }
        />
        {props.googleMapsIframeSrc &&
          <iframe
            src={props.googleMapsIframeSrc}
            width="100%"
            height="450"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            aria-hidden="false"
            tabIndex={0}>
          </iframe>
        }
      </Card>
    </div>
  );
}
